import { styled } from "@schaeffler-commerce/design-system";

/**
 * Migrated from styles/jsp/header.less (header.scha__main-header): relative
 * stacking above main content with responsive bottom spacing. The
 * `scha__main-header` class stays on the element so page-level overrides keep
 * winning by specificity (e.g. FreeCapacityPushPage's
 * `.page-freeCapacityCockpit header.scha__main-header.scha__main-header`).
 */
export const ShellHeaderRoot = styled("header", {
  shouldForwardProp: (prop) => prop !== "hasCustomHeader",
})<{ hasCustomHeader?: boolean }>(({ hasCustomHeader, theme }) => ({
  position: "relative",
  zIndex: 2,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("desktop-s")]: {
    marginBottom: theme.spacing(3),
  },
  ...(hasCustomHeader && {
    "&&&": {
      position: "sticky",
      top: 0,
      zIndex: theme.zIndex.appBar,
      marginBottom: 0,
    },
  }),
}));
